module.exports = __webpack_public_path__ + "static/media/mc50.a67deb8b.mp3";